import { fromNode, ViewModel } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import type { CSSStyleSheetModel } from '../CSSStyleSheet/ViewModel'
import type { PageModel } from '../Page/ViewModel'
import type { QueryModel } from '../Query/ViewModel'
import type { VariableModel } from '../Variable/ViewModel'
import type { AppPlugin } from './plugin'
import type { AppNode } from './TypedNode'

export class AppModel extends ViewModel {
  @fromNode()
  @reactive('shallow')
  pages: PageModel[] = []

  @fromNode()
  @reactive('shallow')
  queries: QueryModel[] = []

  @fromNode()
  @reactive('shallow')
  stylesheets: CSSStyleSheetModel[] = []

  @fromNode()
  @reactive('shallow')
  variables: VariableModel[] = []

  get plugin() {
    return this.getPlugin<AppPlugin>()
  }

  get router() {
    return this.getTypedNode<AppNode>().router
  }
}
